import { forwardRef } from 'react';

//* Style
import EditorStyle from './style';

const Editor = forwardRef(({ className, data }, ref) => {
	const modifiedHtml =
		typeof window !== 'undefined' && data
			? (() => {
					const doc = new DOMParser().parseFromString(data, 'text/html');
					doc.querySelectorAll('li').forEach((li) => {
						if (li.firstElementChild?.tagName === 'STRONG' && !li.firstChild?.previousSibling) {
							li.classList.add('bold-marker');
						}
					});
					return doc.body.innerHTML;
			  })()
			: data || '';

	return (
		<EditorStyle
			dangerouslySetInnerHTML={{ __html: modifiedHtml }}
			className={`editor-wrapper ${className || ''}`}
			ref={ref}
		/>
	);
});

export default Editor;
